// Normalizes the lighter "preview row" shape returned by the trending and
// history endpoints (snake_case DB fields) into one consistent camelCase shape
// matching BattlePreviewCard's props.
export class BattlePreview {
  constructor(raw) {
    this.id = raw.id;
    this.char1 = raw.char1;
    this.char2 = raw.char2;
    this.winnerName = raw.winner_name ?? raw.winnerName ?? null;
    this.sceneImageUrl = raw.scene_image_url ?? raw.sceneImageUrl ?? null;
    this.battleCount = raw.battle_count ?? raw.battleCount ?? null;
    this.searchedAt = raw.searched_at ?? raw.searchedAt ?? null;
  }

  static fromJSON(raw) {
    return raw ? new BattlePreview(raw) : null;
  }

  static fromList(rawList) {
    return Array.isArray(rawList) ? rawList.map((raw) => new BattlePreview(raw)) : [];
  }
}
